module.exports = __webpack_public_path__ + "img/list11.fae8b09a.jpg";